import React, { useEffect, useState } from "react";
import Head from "../../layout/head/Head";
import Content from "../../layout/content/Content";
import DatePicker from "react-datepicker";
import { orderData } from "../pre-built/orders/OrderData";
import axios from "axios";
import {useHistory} from 'react-router-dom';
import { API_URL } from "../../constent";

import {
  Block,
  BlockHeadContent,
  BlockTitle,
  BlockBetween,
  BlockHead,
  DataTableHead,
  DataTableItem,
  DataTableRow,
  Icon,
  TooltipComponent,
  PaginationComponent,
  PreviewAltCard,
  Row,
  Col,
  RSelect,
} from "../../components/Component";
import { getDateStructured } from "../../utils/Utils";
import { UncontrolledDropdown, DropdownMenu, DropdownToggle, DropdownItem, Button, Modal, ModalBody } from "reactstrap";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom/cjs/react-router-dom";

const Uploaddocs = ( {match }) => {

  const poposer_id = match.params.id;

  const [data, setData] = useState([]);
  const [smOption, setSmOption] = useState(false);
  const [loading, setLoading] = useState(false);
  const [getload, getLoading] = useState(false);
  const [formData, setFormData] = useState([]);
  const [refresh, setRefresh] = useState(false);

  const history = useHistory();

  const [view, setView] = useState({
    add: false,
    details: false,
  });

  const [file, setFile] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage] = useState(7);
  const [fileName, setFileName] = useState("Choose file");

  // Changing state value when searching name
  useEffect(() => {
        axios.get(`${API_URL}getproposer_doc/${poposer_id}`).then((result)=>
        {
            console.log(result.data);
            setData(result.data);
            getLoading(false);
        })
  }, [refresh]);

  if (getload) {
    return(
       <>
         <p>Loading....</p>
       </>
    ) 
} 


  // toggle function to view order details
  const toggle = (type) => {
    setView({
      add: type === "add" ? true : false,
      details: type === "details" ? true : false,
    });
  };

 
  const onSubmit = async (e) => {
    e.preventDefault();

    if (!file) {
      alert("Please select a file to upload.");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);
    formData.append("poposer_id", poposer_id);

    try {
      const response = await axios.post(`${API_URL}uploaddoc`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.status === 200) {
        setRefresh(true);
        alert("File uploaded successfully!");
        onFormCancel();
        window.location.reload(); 

      }
    } catch (error) {
      console.error(error);
      alert("Error uploading file.");
      onFormCancel();
    }
  };


  const onFileChange = (e) => {
    setFile(e.target.files[0]);
    if (e.target.files && e.target.files[0]) {
      setFileName(e.target.files[0].name);
    }
  };

  // function to close the form modal
  const onFormCancel = () => {
    setView({ add: false, details: false });
  };


  // function to delete a Order
  const deleteOrder = (id) => {
    axios.get(`${API_URL}deletedoc/${id}`).then((result)=>
    {
        console.log(result.data);
        setRefresh(true);
    })

  };


  // Get current list, pagination
  const indexOfLastItem = currentPage * itemPerPage;
  const indexOfFirstItem = indexOfLastItem - itemPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

  // Change Page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <React.Fragment>
      <Head title="Proposers Docs"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle>Proposers Docs</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand mr-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setSmOption(!smOption);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div className="toggle-expand-content" style={{ display: smOption ? "block" : "none" }}>
                  <ul className="nk-block-tools g-3">
                    <li className="nk-block-tools-opt">
                      <Button
                        className="toggle d-none d-md-inline-flex"
                        color="primary"
                        onClick={() => {
                          toggle("add");
                        }}
                      >
                        <Icon name="plus"></Icon>
                        <span> Upload Docs</span>
                      </Button>
                    </li>
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <div className="nk-tb-list is-separate is-medium mb-3">
            <DataTableHead className="nk-tb-item">
            
              <DataTableRow>
                <span className="sub-text">File Name</span>
              </DataTableRow>
              <DataTableRow size="md">
                <span className="sub-text">Docs</span>
              </DataTableRow>
              <DataTableRow size="md">
                <span className="sub-text">View</span>
              </DataTableRow>

              <DataTableRow className="text-right">
                <span className="sub-text">Action</span>
              </DataTableRow>

            </DataTableHead>

            {currentItems.length > 0
              ? currentItems.map((item) => (
                  <DataTableItem key={item.id}>

                    <DataTableRow>
                        {item.filename}
                    </DataTableRow>
                    <DataTableRow size="md">
                      <img src={item.filepath} style={{maxWidth:'80px'}}/>
                    </DataTableRow>

                    <DataTableRow size="md">
                      <a href={item.filepath} className="btn btn-sm btn-warning" target="_blank">View</a>
                    </DataTableRow>

                
                    <DataTableRow className="nk-tb-col-tools">
                      <ul className="nk-tb-actions gx-1">
                
                        <li>
                          <UncontrolledDropdown>
                            <DropdownToggle tag="a" className="btn btn-icon dropdown-toggle btn-trigger">
                              <Icon name="more-h"></Icon>
                            </DropdownToggle>
                            <DropdownMenu right>
                              <ul className="link-list-opt no-bdr">
                                
                                <li>
                                  <DropdownItem
                                    tag="a"
                                    href="#dropdown"
                                    onClick={(ev) => {
                                      ev.preventDefault();
                                      deleteOrder(item.id);
                                    }}
                                  >
                                    <Icon name="trash"></Icon>
                                    <span>Delete</span>
                                  </DropdownItem>
                                </li>

                              </ul>
                            </DropdownMenu>
                          </UncontrolledDropdown>
                        </li>
                      </ul>
                    </DataTableRow>
                  </DataTableItem>
                ))
              : null}
          </div>
          <PreviewAltCard>
            {data.length > 0 ? (
              <PaginationComponent
                itemPerPage={itemPerPage}
                totalItems={data.length}
                paginate={paginate}
                currentPage={currentPage}
              />
            ) : (
              <div className="text-center">
                <span className="text-silent">No orders found</span>
              </div>
            )}
          </PreviewAltCard>
        </Block>

        <Modal isOpen={view.add} toggle={() => onFormCancel()} className="modal-dialog-centered" size="lg">
          <ModalBody>
            <a href="#cancel" className="close">
              {" "}
              <Icon
                name="cross-sm"
                onClick={(ev) => {
                  ev.preventDefault();
                  onFormCancel();
                }}
              ></Icon>
            </a>
            <div className="p-2">
              <h5 className="title">Upload Docs</h5>
              <div className="mt-4">
                <form onSubmit={onSubmit}>
                  <Row className="g-3">
                    <Col md="12">
                        <div className="form-group">
                            <label className="form-label"> Upload File</label>
                            <div className="form-control-wrap">
                                <div className="custom-file">
                                    <input type="file" onChange={onFileChange} className="custom-file-input" id="customMultipleFiles" />
                                    <label className="custom-file-label" htmlFor="customMultipleFiles">
                                    {fileName}
                                    </label>
                                </div>
                            </div>
                        </div> 
                    </Col>

                    <Col size="12">
                      <Button color="primary" disabled={loading} type="submit">
                        <Icon className="plus"></Icon>
                        <span>{loading ? 'Loading...' : 'Upload Docs'}</span>
                      </Button>
                    </Col>
                  </Row>
                </form>
              </div>
            </div>
          </ModalBody>
        </Modal>

      </Content>
    </React.Fragment>
  );
};

export default Uploaddocs;
